import { DEFAULT_MEDICAL_TITLE } from 'App/Components/TitleSelector/TitleSelector';

export const MEXICO_COUNTRY_CODE = 142;

export const UNSPECIFIED_ENTITY_NAME = 'NO ESPECIFICADO';

export const IGNORED_ENTITY_NAME = 'SE IGNORA';

/** Entidade usada quando a residência está fora do México. */
export const UNSPECIFIED_ENTITY_CODE = 88;

export const SPECIAL_ENTITY_MAP: Record<
	number,
	{ municipality: number; locality: number }
> = {
	99: { municipality: 998, locality: 9998 },
	0: { municipality: 999, locality: 9999 },
	88: { municipality: 998, locality: 9998 },
};

export const DEFAULT_FORM_VALUES = {
	title: DEFAULT_MEDICAL_TITLE as string,
	firstName: '',
	middleName: '',
	lastName: '',
	hasNoMiddleName: false,
	hasNoLastName: false,
	birthDate: '',
	sex: '',
	contactNumber: '',
	countryCode: '',
	federalEntityCode: '',
	nationalityCode: '',
	nationalIdentity: '',
	countryResidenceCode: '',
	federalEntityResidenceCode: '',
	municipalityResidenceCode: '',
	localityResidenceCode: '',
	professionalLicenseId: '',
	university: '',
	doctorPersonalTypeId: '',
	specialties: [] as { id: string; name?: string }[],
	branchOffices: [] as { id: string; name?: string }[],
	email: '',
};
